/**
 * Created by lihanying on 2017/7/14.
 */

export const GETCLUBWALLET = 'GETCLUBWALLET'



// WEBPACK FOOTER //
// ./src/containers/ClubMember/constants.js